import { Navigate, useLocation, useParams } from 'react-router-dom'

export default function RedirectToUserActivityPage() {
  const { planId } = useParams()
  const location = useLocation()

  return <Navigate to={`/my-activity/${planId}${location?.hash}`} />
}
